module.exports = __webpack_public_path__ + "img/new.e7cbd241.png";